<template>
  <div v-if="!isCardList && isEmptyList" class="empty-tag-list">-</div>
  <div v-else class="tag-list-container" :class="isCardList && 'is-card-list'">
    <div class="tag-list">
      <el-tooltip
        v-for="(tag, index) in displayTagList"
        effect="light"
        placement="bottom"
        popper-class="light-tooltip-popper"
        :key="index"
      >
        <div class="tag">{{ tag.i18nName }}</div>
        <template #content>
          <div class="tag">{{ tag.i18nName }}</div>
          <div class="operator">{{ getOperatorName(tag) }}</div>
          <div class="operate-time">{{ tag.operate_time|formatDate }}</div>
        </template>
      </el-tooltip>
    </div>
    <el-popover v-if="hasMore" class="has-more" popper-class="tag-list-container more-tag-container" :placement="isCardList ? 'bottom' : 'left-start'"  @click.native.stop>
      <template #reference>
        <div>...</div>
      </template>
      <div class="tag-list">
        <el-tooltip
          v-for="(tag, index) in moreTagList"
          effect="light"
          placement="bottom"
          popper-class="light-tooltip-popper"
          :key="index"
        >
          <div class="tag">{{ tag.i18nName }}</div>
          <template #content>
            <div class="tag">{{ tag.i18nName }}</div>
            <div class="operator">{{ getOperatorName(tag) }}</div>
            <div class="operate-time">{{ tag.operate_time|formatDate }}</div>
          </template>
        </el-tooltip>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { addI18nProperty } from '@/i18n'
import _ from 'lodash'

export default {
  props: {
    tagList: {
      type: Array,
      default: null
    },
    isCardList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    isEmptyList () {
      return !this.tagList || this.tagList.length < 1
    },
    displayTagList () {
      return _.map(_.slice(this.tagList, 0, 2), tag => addI18nProperty(tag, 'i18nName', 'cn_name', 'name'))
    },
    moreTagList () {
      return _.map(_.slice(this.tagList, 2), tag => addI18nProperty(tag, 'i18nName', 'cn_name', 'name'))
    },
    hasMore () {
      return this.tagList?.length > 2
    }
  },
  created () {

  },
  methods: {
    getOperatorName (tag) {
      const operator = tag.operator
      if (operator && operator.id) {
        return tag.operator.name
      } else {
        return this.$t('admin.crm.label.tag.systemOperator')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-list-container {
  display: flex;

  .tag-list {
    .tag {
      width: 120px;
      height: 26px;
      line-height: 26px;
      padding: 0 10px;
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      word-break: break-word;

      + .tag {
        margin-top: 4px;
      }
    }
  }

  .has-more {
    display: block;
    line-height: 1;
    margin-top: auto;
    margin-left: 4px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
  }

  &.more-tag-container {
    .tag-list {
      line-height: 1;
      overflow: hidden;
    }
  }

  &.is-card-list {
    display: block;
    margin-top: 5px;

    .tag-list {
      .tag {
        width: 80px;
      }
    }

    .has-more {
      margin-left: 0;
    }
  }
}
</style>
